import { themeConfig } from '../../tailwind.config'

/**
 * Layout and Responsive Breakpoints
 * Parsed from shared tailwind config
 */
export const BREAKPOINTS = {
  SM: Number.parseInt(themeConfig.screens.sm, 10),
  MD: Number.parseInt(themeConfig.screens.md, 10),
  LG: Number.parseInt(themeConfig.screens.lg, 10),
  XL: Number.parseInt(themeConfig.screens.xl, 10),
  '2XL': Number.parseInt(themeConfig.screens['2xl'], 10),
} as const

/**
 * Mobile device detection breakpoint
 */
export const MOBILE_BREAKPOINT = BREAKPOINTS.MD
